import React, { useState, useRef, useEffect } from "react";

export function GastosSelector({ 
  options = [], 
  onSeleccionChange, 
  className = "",
}) {
  const [seleccionado, setSeleccionado] = useState(null);
  const [abierto, setAbierto] = useState(false);
  const dropdownRef = useRef(null);

  const opcionNula = { IdCompraExterna: null, nombre: "Sin información disponible", descripcion: null };
  
  const opcionesBase = options;
  const opcionesAUsar = [opcionNula, ...opcionesBase];

  const onChoose = (opcion) => {
    setSeleccionado(opcion.IdCompraExterna);
    onSeleccionChange && onSeleccionChange(opcion);
    setAbierto(false);
  };

  const estaSeleccionado = (opcionId) => {
    return seleccionado === opcionId;
  };

  const obtenerOpcionSeleccionada = () => {
    return opcionesAUsar.find(op => op.IdCompraExterna === seleccionado) || opcionNula;
  };
  
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setAbierto(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const opcionSeleccionada = obtenerOpcionSeleccionada();

  return (
    <div className={`${className} position-relative`} ref={dropdownRef}>
      <button
        type="button"
        className="d-flex justify-content-between align-items-center w-100"
        onClick={() => setAbierto(!abierto)}
        style={{
          textAlign: 'left',
          backgroundColor: '#fff',
          minHeight: '48px',
          padding: '8px 12px',
          transition: 'none',
          border: '1px solid #6c757d',
          borderRadius: '0.25rem',
          color: '#212529',
          outline: 'none',
          boxShadow: 'none'
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.backgroundColor = '#fff';
          e.currentTarget.style.color = '#212529';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.backgroundColor = '#fff';
          e.currentTarget.style.color = '#212529';
        }}
      >
        {opcionSeleccionada.IdCompraExterna ? (
          <div className="d-flex flex-column align-items-start w-100" style={{ pointerEvents: 'none' }}>
            <span className="font-weight-medium p-0 m-0" style={{ fontSize: '0.95rem', color: '#212529' }}>
              Fecha: {opcionSeleccionada.FechaMovimiento} | Nro. Documento: {opcionSeleccionada.NroDocumentoSunat} | Total: S/ {opcionSeleccionada.Total}
            </span>
            {opcionSeleccionada.RazonSocial && (
              <small style={{ color: '#6c757d' }}>
                {opcionSeleccionada.RazonSocial} | Glosa: {opcionSeleccionada.Glosa}
              </small>
            )}
          </div>
        ) : (
          <span style={{ color: '#6c757d', pointerEvents: 'none' }}>{opcionSeleccionada.nombre}</span>
        )}
        <i className={`fas fa-chevron-${abierto ? 'up' : 'down'} ml-2`} style={{ color: '#212529', pointerEvents: 'none' }}></i>
      </button>

      {abierto && (
        <div
          className="border shadow-sm"
          style={{
            position: 'absolute',
            top: '100%',
            left: 0,
            right: 0,
            marginTop: '4px',
            maxHeight: '300px',
            overflowY: 'auto',
            borderRadius: '0.375rem',
            backgroundColor: '#fff',
            zIndex: 1050
          }}
        >
          {opcionesAUsar.map((opcion) => {
            const seleccionado = estaSeleccionado(opcion.IdCompraExterna);
            return (
              <button
                key={opcion.IdCompraExterna}
                type="button"
                className="list-group-item list-group-item-action d-flex justify-content-between align-items-center"
                onClick={() => onChoose(opcion)}
                style={{
                  border: 'none',
                  borderBottom: '1px solid #dee2e6',
                  cursor: 'pointer',
                  padding: '10px 12px',
                  transition: 'none',
                  backgroundColor: seleccionado ? '#01A59C' : '#fff',
                  color: seleccionado ? '#fff' : '#212529'
                }}
              >
                {opcion.IdCompraExterna ? (
                  <div className="d-flex flex-column align-items-start w-100">
                    <span className="font-weight-medium p-0 m-0" style={{ color: seleccionado ? '#fff' : '#212529' }}>
                      Fecha: {opcion.FechaMovimiento} | Nro. Documento: {opcion.NroDocumentoSunat} | Total: S/ {opcion.Total} | Glosa: {opcion.Glosa}
                    </span>
                    {opcion.RazonSocial && (
                      <small style={{ color: seleccionado ? '#fff' : '#6c757d' }}>
                        {opcion.RazonSocial}
                      </small>
                    )}
                  </div>
                ) : (
                  <div className="d-flex flex-column align-items-start w-100">
                    <span className="font-weight-medium p-0 m-0" style={{ color: seleccionado ? '#fff' : '#212529' }}>
                      {opcion.nombre}
                    </span>
                  </div>
                )}
                
                {seleccionado && (
                  <i className="fas fa-check ml-2" style={{ color: '#fff' }}></i>
                )}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}